import React from "react";
import { cn } from "../../lib/utils/cn";
import { getDayAndTime } from "../../lib/utils/utils-functions";
import { getMessagePreview } from "./message-preview";
import { UnreadIndicator } from "./unread-indicator.component";
import { useNavigate } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { isDentconnectUser } from "@/lib/utils/is-app-user";

interface ChatPreviewItemProps {
	title: string;
	subtitle: string;
	messageAt: string;
	messageContent: string;
	isSender: boolean;
	active: boolean;
	onClick: () => void;
	unreadCount?: number;
	jobId?: number;
	clientId?: string;
	channelType?: string;
	weAreTheVendor: boolean;
}

export const ChatPreviewItem: React.FC<ChatPreviewItemProps> = ({
	title,
	subtitle,
	messageAt,
	messageContent,
	isSender,
	active,
	onClick,
	unreadCount = 0,
	jobId,
	clientId,
	channelType,
	weAreTheVendor,
}) => {
	const navigate = useNavigate();
	
	const handleJobNavigation = (e: React.MouseEvent) => {
		e.stopPropagation();
		if (jobId && clientId) {
			navigate(`/client/${clientId}/job/${jobId}`);
		}
	};
	
	const isJobChannel = channelType === "job" && jobId && clientId;
	const showJobNavigation = isJobChannel && !isDentconnectUser(import.meta.env) && jobId && clientId && weAreTheVendor;
	return (
		<div
			className={cn(
				"group relative flex cursor-pointer transition-colors bg-slate-100 border-b border-white",
				"px-3 py-2",
				active
					? "bg-blue-100 hover:bg-blue-50"
					: "hover:bg-slate-50",
			)}
			onClick={onClick}
		>
			<div className="flex flex-1 flex-col min-w-0">
				<div className="flex items-center justify-between gap-2">
					<span
						className={cn(
							"font-semibold text-gray-900 truncate text-sm",
						)}
					>
						{title}
					</span>
					<div className="flex items-center gap-2">
						<span className={cn("text-xs text-gray-500 whitespace-nowrap", showJobNavigation && "group-hover:opacity-0")}>
							{getDayAndTime(messageAt)}
						</span>
						{!active && <UnreadIndicator count={unreadCount} showCount={true} className={cn("px-3 bg-blue-500", showJobNavigation && "group-hover:opacity-0")}/>}
					</div>
				</div>
				
				{subtitle && (
					<span className="text-sm text-gray-600 truncate">{subtitle}</span>
				)}
				
				<div className="text-gray-600 truncate text-sm">
					{getMessagePreview(messageContent, isSender)}
				</div>
			</div>
			
			{active && (
				<div className="absolute left-0 top-0 bottom-0 w-1 bg-blue-600" />
			)}
			
			{showJobNavigation && (
				<button
					onClick={handleJobNavigation}
					className="absolute right-2 top-2 opacity-0 group-hover:opacity-100 transition-opacity p-2 bg-white border border-gray-200 shadow-sm rounded-md"
					title="Zum Auftrag wechseln"
				>
					<ExternalLink className="w-4 h-4 text-gray-600" />
				</button>
			)}
		</div>
	);
};